<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form class="dataForm" :rules="rules" ref="form" :model="formParameter" :inline="true" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="sprint代办" prop="name"><el-input :readonly="!disabled" v-model="formParameter.name"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="进度" prop="sadvance" ><el-slider
                v-model="formParameter.sadvance" disabled></el-slider></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="产品代办" prop="problogid">
              <el-input placeholder="请选择产品代办" disabled v-model="proBackLogName" autocomplete="off">
                <template slot="append" v-if="disabled">
                  <el-button type="primary" @click="selectProBaLog()">{{
    proBackLogName != "" ? "重新选择" : "选择"
  }}</el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- <el-form-item label="计划会议" prop="meetingId">
              <el-input placeholder="请选择计划会议" disabled v-model="proBackLogName" autocomplete="off">
                <template slot="append" v-if="disabled">
                  <el-button type="primary" @click="selectProBaLog()">{{
    proBackLogName != "" ? "重新选择" : "选择"
  }}</el-button>
                </template>
              </el-input>
            </el-form-item> -->


            <el-form-item label="计划会议" prop="meetingId">
            <el-select v-model="formParameter.meetingId" clearable placeholder="请选择会议"
                @change="onMeetingChange" style="width:100%">
                <el-option v-for="item in meetingList" :key="item.id" 
                    :label="item.name" :value="item.id">
                    <span style="float: left">{{ item.name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">
                        {{ item.type == 1 ? '站会' : item.type == 2 ? '计划会议' : item.type == 3 ? '评审会议' : '回顾会议' }}
                    </span>
                </el-option>
            </el-select>
        </el-form-item>
          </el-col>
        </el-row>
        <el-row>

          <el-col :span="12">
<el-form-item label="团队成员" prop="pmid">
  <el-autocomplete
    v-model="pmidDisplayName"
    :fetch-suggestions="querySearchMembers"
    :disabled="!disabled"
    placeholder="请选择团队成员"
    value-key="name"
    @select="handleSelectMember"
    style="width: 100%">
    <template slot-scope="{ item }">
      <span>{{ item.name }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.post }}</span>
    </template>
  </el-autocomplete>
</el-form-item>
        </el-col>

          <el-col :span="12">
            <el-form-item label="执行状态" prop="states">

              <select-option-dictionary v-if="disabled" v-model="formParameter.states"
                dkey="spr-backlog-states"></select-option-dictionary>
              <el-input v-else :readonly="!disabled" v-model="formParameter.states" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="预计工时" prop="hopegs"><el-input :readonly="!disabled" @blur="checkHopegs"
                v-model="hopegs" autocomplete="off"></el-input></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="执行周期" prop="pbgntm">
                                                     <!--  pendtm  ,pbgntm  -->
              <el-date-picker :disabled="!disabled" v-model="daterange" value-format="yyyy-MM-dd" type="daterange"
                range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="目标" prop="pgoal">
              <wang-edit v-if="disabled" :isupdt="isUpdtWedit" v-model="formParameter.pgoal"></wang-edit>
              <div style="width: 100%;padding-left: 40px;border: 1px solid #000;border-color: #dcdfe6;" v-else>
                <span v-html="formParameter.pgoal"></span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input :readonly="!disabled" type="textarea" :rows="4" v-model="formParameter.remark"
                autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- 选择产品代办 -->
      <el-dialog title="选择产品清单" :visible.sync="dialogVisible" width="60%" :append-to-body="true">
        <el-tree v-loading="treeLoading" ref="permissionTree" :data="proBackLogList" @node-click="treeClick"></el-tree>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmProBLog">选定产品代办</el-button>
        </span>
      </el-dialog>
    </div>
    <div slot="footer"> 
      <el-button type="primary" v-if="disabled" :loading="confirmLoading" @click="confirm()">确 定
      </el-button>
      <el-button @click="close">关 闭</el-button>
    </div>
  </popup>
</template>

<script>
import meetingApi from '@/api/sprint/meeting/meeting.js';

import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/sprint/sprintBacklog/sprintBacklog.js";
import apiProBLog from "@/api/product/productBacklog/productBacklog.js";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
import tree from "@/components/tree/tree.vue";
import wangEdit from "@/components/wangEdit/wangEdit.vue";
import { log } from "console";

export default {
  name: "edit",
  components: {
    popup,
    selectOptionDictionary,
    tree,
    wangEdit,
  },
  props: ["selectProd", "sprintId"],
  data() {
    return {
      edDisabled: false,
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {},
      dialogVisible: false,
      pgoalManuallyEdited: false, 
      //产品列表全部数据
      proBackLogList: [],
      //代办名称
      proBackLogName: "",
      proBLogData: {},
      pmidDisplayName: '',  // 团队成员输入框显示的名字
      meetingList: [],  // 会议列表
      meetingId: '',  // 关联的会议ID
      meetingParticipants: [],  // 当前会议参会人对应的成员对象
      pbgntm: "",
      pendtm: "",
      daterange: [],  
      hopegs: 0,
      hasArriHopegs: 0,   //剩余可派工时
      orgHopegs: 0,     //原始已分配的工时-修改时用

      //团队成员信息
      teamMembers: [],
      //选择的团队成员
      sleTeamMember: {},
      treeLoading: false,

      isUpdtWedit: false, //用于更新wangEdit

      rules: {
        name: [
          {
            validator: this.$validate.required,
            trigger: 'blur'
          },
        ]
      }
    };
  },
  computed: {
  currentTeamMembers() {
    // 选了会议 → 只显示会议参会人；没选 → 显示全部团队成员
    if (this.meetingParticipants && this.meetingParticipants.length > 0) {
      return this.meetingParticipants;
    }
    return this.teamMembers;
  }
},
  watch: {
  'formParameter.pgoal'(newVal, oldVal) {
    // 只在弹窗打开、表单已初始化时判断
    if (this.popupLoading) return;
    
    // 由自动填充触发的赋值，不标记
    if (this._settingPgoal) return;
    
    // 用户手动改 → 标记
    this.pgoalManuallyEdited = true;
  }
},
  methods: {
    checkHopegs() {

      //console.log(this.hasArriHopegs, this.orgHopegs, this.hopegs)

      if (this.orgHopegs) {  //修改
        //     16             12                   8
        if ((this.hopegs - this.orgHopegs) > this.hasArriHopegs) {
          this.$utils.confirm.warning(
            "修改错误",
            "计划工时超过 " + (this.orgHopegs + this.hasArriHopegs) + " 工时"
          );
        }
      } else {   //添加
        if (this.hopegs > this.hasArriHopegs) {
          this.$utils.confirm.warning(
            "新增错误",
            "计划工时超过 " + this.hasArriHopegs + " 工时"
          );
        }
      }

    },
    //打开弹框
    open(parameter, title, disabled, size) {
      console.log("parameter", parameter);


      this.proBackLogList = [];
      this.proBLogData = [];
      this.proBackLogName = "";
      this.sleTeamMember = {};
      this.parameter = parameter;

      this.hasArriHopegs = parameter.hasArriHopegs

      this.teamMembers = parameter.teamAndMember;
      this.formParameter.pmid = '';  // 明确初始化
      this.disabled = disabled === undefined ? true : disabled;
      console.log("disabled", disabled)
      this.$refs.popup.open(title, size);
      this.$nextTick(() => {
        this.init();
      });
    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.formParameter = {};
      this.hopegs = 0
      this.pmidDisplayName = ''; 
      this.pgoalManuallyEdited = false;  
      this.$refs.popup.close();
      this.meetingParticipants = [];
    },

    /*关闭选择成员弹出框
    outClose(done) {
      done()
    },*/
    // 选择产品代办
    selectProBaLog() {

      if (this.proBackLogName.length > 0) {
        this.proBackLogName = "";
        this.proBLogData = false

      } else {
        this.dialogVisible = true;
      }

    },
    treeClick(data) {
      this.proBLogData = data;
    },
    handleChangeJhhours() { },
    //提交选择的产品代办
    confirmProBLog() {
      let delIdex = [];
      //验证是否不超过3级
      if (this.proBLogData.children) {
        this.proBLogData.children.forEach((L1, idx) => {
          if (L1.children) {
            delIdex.push(idx);
          }
        });
      }

      if (delIdex.length > 0) {
        if (delIdex.length == this.proBLogData.children.length) {
          this.$utils.confirm.warning(
            "错误",
            "选择待办不能超过2级,全部2级节点均有3级节点，添加失败"
          );
          return false;
        } else {
          this.$utils.confirm.warning(
            "选择待办不能超过2级",
            "3级以上节点需另行添加Sprint待办!"
          );
          let i = 0;
          delIdex.forEach((idx) => {
            this.proBLogData.children.splice(idx - i, 1);
            i++;
          });
        }
      }

      apiProBLog.toUpdate({ id: this.proBLogData.id }, res => {

        this.proBLogData = res.data;
        console.log("treeClick ====>    ", this.proBLogData);
        this.hopegs = this.proBLogData.manDay * 8;

        this.formParameter.pgoal = this.proBLogData.content
        //手动刷新wangEdit
        this.isUpdtWedit = true;
        setTimeout(() => {
          this.isUpdtWedit = false;
        }, 100);

        this.proBackLogName = this.proBLogData.name;

        this.formParameter.problogid = this.proBLogData.id;
        this.dialogVisible = false;

      });




    },

    //确认团队成员
    // confirmTeamMember() {
    // 	this.formParameter.pmid = this.sleTeamMember.id
    // },
    //提交表单
    confirm() {
      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;

        this.formParameter.pbgntm = this.pbgntm;
        this.formParameter.pendtm = this.pendtm;
        this.formParameter.hopegs = this.hopegs;

        if (!this.parameter.id) {
          //添加
          let parameter = this.$utils.merger(this.formParameter);
          parameter.children = this.proBLogData.children;

          api.save(
            parameter,
            (response) => {

              this.appendToMeetingSummary();
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              //给父组件说成功了
              this.$emit('success', true);
              this.close();
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );

          /* api.isSuperWorkingHours(
             parameter,
             (res) => {
               api.save(
                 parameter,
                 (response) => {
                   this.$utils.msg.success(response.msg);
                   this.confirmLoading = false;
                   this.close();
                   this.$parent.list();
                 },
                 (response) => {
                   this.$utils.msg.warning(response.msg);
                   this.confirmLoading = false;
                 }
               );
             },
             (error) => {
               this.$utils.msg.warning(error.msg);
               api.save(parameter, (response) => {
                   // this.$utils.msg.success(error.msg+"111111");
                   this.confirmLoading = false;
                   this.close();
                   this.$parent.list();
                 },
                 (response) => {
                   this.$utils.msg.warning(error.msg);
                   this.confirmLoading = false;
                 })
               // this.$utils.msg.warning(error.msg);
               this.confirmLoading = false;
             }
           );
 
           */
        } else {
          //编辑
          delete this.formParameter.teamAndMember;
          delete this.formParameter.children
          delete this.formParameter.crer
          delete this.formParameter.crtm
          delete this.formParameter.mdtm
          delete this.formParameter.mder
          delete this.formParameter.lastDrecrtm
          delete this.formParameter.sprintId
          delete this.formParameter.pmidDisplayName;
          //  api.isSuperWorkingHours( {sprid:this.formParameter.sprid,hopegs:this.formParameter.hopegs} ,
          //     (res) => {
          api.update(
            this.formParameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
          // },
          //   (error) => {
          //    this.$utils.msg.warning(error.msg);
          //     this.confirmLoading = false;
          //  }
          //  );
        }
      });
    },
    init() {
      this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = {};
      //清楚校验
      this.$refs.form.clearValidate();
      //获取sprint列表
      this.formParameter.sprid = this.sprintId;

      if (this.parameter.sprid) {
      this.loadMeetings(this.parameter.sprid);
      }

      const proId = localStorage.getItem("pid");

      apiProBLog.list({ productId: proId }, (response) => {
        this.proBackLogList = response.data;
        //console.log("this.proBackLogList", this.proBackLogList)
      });
      if (this.parameter.id) {
        //console.log("zheli");
        //编辑查询数据
        let parameter = {
          id: this.parameter.id,
        };
        api.toUpdate(parameter, (response) => {
          this.formParameter = response.data;
          // 编辑时已有内容，视为手动改过，不再自动覆盖
          if (this.formParameter.pgoal) {
            this.pgoalManuallyEdited = true;
          }


          // 回填团队成员显示名
          if (this.formParameter.pmid) {
            const member = this.teamMembers.find(m => m.id === this.formParameter.pmid);
            if (member) this.pmidDisplayName = member.name;
          }
          this.orgHopegs = this.formParameter.hopegs

          console.log(this.formParameter);
          if (this.formParameter.childNode != undefined) {
            this.edDisabled = true;
          } else {
            this.edDisabled = false;
          }
          //console.log("编辑查询数据", this.formParameter)
          this.sleTeamMember = {
            id: this.formParameter.pmid,
            name: this.formParameter.tmName,
          };
          this.proBackLogName = this.formParameter.problogName;

          this.pbgntm = this.formParameter.pbgntm;
          this.pendtm = this.formParameter.pendtm;
          this.hopegs = this.formParameter.hopegs

          if (this.formParameter.pgoal) {
            this.isUpdtWedit = true;
            setTimeout(() => {
              this.isUpdtWedit = false;
            }, 100);
          }

          this.popupLoading = false;
        });
      } else {
        //添加
        this.pbgntm = this.parameter.startTime;
        this.pendtm = this.parameter.endTime;
        this.formParameter.states = "未开始";
        this.popupLoading = false;
      }
// 编辑时如果已经关联会议，加载参会人
if (this.formParameter.meetingId) {
  meetingApi.toUpdate({ id: this.formParameter.meetingId }, res => {
    if (res.data && res.data.participant) {
      const names = res.data.participant.split(',').map(n => n.trim());
      this.meetingParticipants = this.teamMembers.filter(item => names.includes(item.name));
      if (this.formParameter.pmid) {
        const member = this.teamMembers.find(m => m.id === this.formParameter.pmid);
        if (member) this.pmidDisplayName = member.name;
      }

    }
  });
}



    },


    // 加载会议列表
loadMeetings(sprintId) {
    api.getMeetingsBySprint({ sprintId: sprintId }, response => {
        this.meetingList = response.data || [];
    }, error => {
        console.warn('获取会议列表失败', error);
    });
},

// 会议变更事件
onMeetingChange(meetingId) {
  this.formParameter.pmid = '';
  this.pmidDisplayName = '';
  this.meetingParticipants = [];
  this.pgoalManuallyEdited = false;

  if (meetingId) {
    meetingApi.toUpdate({ id: meetingId }, response => {
      const meeting = response.data;
      if (meeting) {
        // ========== 改动部分 ==========
        const allNames = [];
        // 主持人
        if (meeting.host) {
          allNames.push(meeting.host.trim());
        }
        // 参会人（逗号分隔）
        if (meeting.participant) {
          meeting.participant.split(',').forEach(n => {
            const name = n.trim();
            if (name) allNames.push(name);
          });
        }
        // 去重
        const uniqueNames = [...new Set(allNames)];
        
        this.meetingParticipants = this.teamMembers.filter(item => uniqueNames.includes(item.name));
        // ==============================
        
        this._autoFillPgoal(meeting.objective, '');
      }
    });
  }
},

// el-autocomplete 的搜索
querySearchMembers(queryString, cb) {
  const members = this.currentTeamMembers.map(m => ({
    ...m,
    value: m.name
  }));
  cb(members);
},

handleSelectMember(item) {
  this.formParameter.pmid = item.id;
  this.pmidDisplayName = item.name;
  
  if (this.formParameter.meetingId) {
    meetingApi.toUpdate({ id: this.formParameter.meetingId }, response => {
      const meeting = response.data;
      if (meeting) {

        
        this.pgoalManuallyEdited = false;
        this._autoFillPgoal(meeting.objective, item.name);
      }
    });
  }
},
// 从会议目的中，按成员姓名过滤内容
filterObjectiveByMember(objective, memberName) {
  if (!objective) return '';
  
  // 1. 处理 HTML：<br>、</p> 视为换行
  let text = objective
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<[^>]+>/g, '')      // 去掉剩下的 HTML 标签
    .replace(/&nbsp;/g, ' ')      // 处理空格实体
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&');
  
  // 2. 拆分非空行
  const lines = text.split(/\r?\n/).map(l => l.trim()).filter(l => l);
  
  if (!memberName) {
    // 没指定成员 → 返回全部（但保持原始 HTML 更好）
    return objective;  // ← 返回原始 HTML，保留富文本格式
  }
  
  // 3. 匹配 "姓名：内容" 或 "姓名:内容"
  const matched = lines.filter(line => {
    const m = line.match(/^(.+?)[：:]/);
    if (!m) return false;
    return m[1].trim() === memberName;
  });
  // 4. 把匹配到的行重新包成 HTML（如果 pgoal 是富文本）
  return matched.map(line => `<p>${line}</p>`).join('');
},

// 自动填充待办目标（带手动标记保护）
_autoFillPgoal(objective, memberName) {
  // 如果用户手动改过，就不覆盖
  if (this.pgoalManuallyEdited) return;
  
  const content = this.filterObjectiveByMember(objective, memberName);
  
  // 设置标记，避免被 watch 误判为手动修改
  this._settingPgoal = true;
  this.formParameter.pgoal = content;
  this.isUpdtWedit = true;
  this.$nextTick(() => {
    this.isUpdtWedit = false;
    this._settingPgoal = false;
  }, 300);
},
// 把待办信息追加到关联会议的纪要
appendToMeetingSummary() {
  // 先把值存下来（因为 close() 会清空 formParameter）
  const meetingId = this.formParameter.meetingId;
  const memberName = this.pmidDisplayName || '';
  const hopegs = this.hopegs || 0;
  const pgoalHtml = this.formParameter.pgoal || '';
  const pbgntm = this.formParameter.pbgntm || '';
  const pendtm = this.formParameter.pendtm || '';

  if (!meetingId) return;

  meetingApi.toUpdate({ id: meetingId }, (res) => {
    const meeting = res.data;
    if (!meeting) return;

    const appendHtml =
      `<p>${memberName} 预计工时：${hopegs}小时</p>` +
      pgoalHtml +
      `<p>执行周期：${pbgntm} 到 ${pendtm}</p>` +
      `<hr/>`;

    const oldSummary = meeting.summary || '';
    const newSummary = oldSummary + appendHtml;

    meetingApi.update(
      { id: meetingId, summary: newSummary },
      () => console.log('会议纪要追加成功'),
      (err) => console.warn('会议纪要追加失败', err)
    );
  }, (err) => {
    console.warn('查询会议详情失败', err);
  });
},

}

};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
